import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getDoneWorksFinanceAttributions: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].GET_DONE_WORKS_FINANCE_ATTRIBUTIONS,
	},
	getDoneWorksFinanceAttributionPreview: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].GET_DONE_WORKS_FINANCE_ATTRIBUTION_PREVIEW,
	},
	getDoneWorksFinanceAttributionPopup: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].GET_DONE_WORKS_FINANCE_ATTRIBUTION_POPUP,
	},
	createDoneWorksFinanceAttribution: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].CREATE_DONE_WORKS_FINANCE_ATTRIBUTION,
	},
	getDoneWorksFinanceAttribution: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].GET_DONE_WORKS_FINANCE_ATTRIBUTION,
	},
	patchDoneWorksFinanceAttribution: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].PATCH_DONE_WORKS_FINANCE_ATTRIBUTION,
	},
	putDoneWorksFinanceAttribution: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].PUT_DONE_WORKS_FINANCE_ATTRIBUTION,
	},
	deleteDoneWorksFinanceAttribution: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].DELETE_DONE_WORKS_FINANCE_ATTRIBUTION,
	},
}